import { GridLocaleText } from '@mui/x-data-grid';

const localeTextPTBR: GridLocaleText = {
  noRowsLabel: 'Nenhuma linha',
  noResultsOverlayLabel: 'Nenhum resultado encontrado.',
  toolbarDensity: 'Densidade',
  toolbarDensityLabel: 'Densidade',
  toolbarDensityCompact: 'Compacta',
  toolbarDensityStandard: 'Padrão',
  toolbarDensityComfortable: 'Confortável',
  toolbarColumns: 'Colunas',
  toolbarColumnsLabel: 'Exibir Colunas',
  toolbarFilters: 'Filtros',
  toolbarFiltersLabel: 'Mostrar Filtros',
  toolbarFiltersTooltipHide: 'Ocultar filtros',
  toolbarFiltersTooltipShow: 'Mostrar filtros',
  toolbarFiltersTooltipActive: (count) =>
    count !== 1 ? `${count} filtros ativos` : `${count} filtro ativo`,
  toolbarQuickFilterPlaceholder: 'Buscar...',
  toolbarQuickFilterLabel: 'Pesquisa rápida',
  toolbarQuickFilterDeleteIconLabel: 'Limpar pesquisa',
  toolbarExport: 'Exportar',
  toolbarExportLabel: 'Exportar',
  toolbarExportCSV: 'Exportar para CSV',
  toolbarExportPrint: 'Imprimir',
  toolbarExportExcel: 'Exportar para Excel',
  columnsManagementSearchTitle: 'Buscar Coluna',
  columnsManagementNoColumns: 'Nenhuma coluna disponível',
  columnsManagementShowHideAllText: 'Mostrar/Ocultar todas',
  columnsManagementReset: 'Redefinir',
  columnsManagementDeleteIconLabel: 'Excluir',
  filterPanelAddFilter: 'Adicionar Filtro',
  filterPanelRemoveAll: 'Remover Tudo',
  filterPanelDeleteIconLabel: 'Excluir',
  filterPanelLogicOperator: 'Operador lógico',
  filterPanelOperator: 'Operador',
  filterPanelOperatorAnd: 'E',
  filterPanelOperatorOr: 'OU',
  filterPanelColumns: 'Colunas',
  filterPanelInputLabel: 'Valor',
  filterPanelInputPlaceholder: 'Filtrar valor...',
  filterOperatorContains: 'Contém',
  filterOperatorDoesNotContain: 'Não contém',
  filterOperatorEquals: 'Igual a',
  filterOperatorDoesNotEqual: 'Diferente de',
  filterOperatorStartsWith: 'Começa com',
  filterOperatorEndsWith: 'Termina com',
  filterOperatorIs: 'É',
  filterOperatorNot: 'Não é',
  filterOperatorAfter: 'Depois de',
  filterOperatorOnOrAfter: 'Em ou depois de',
  filterOperatorBefore: 'Antes de',
  filterOperatorOnOrBefore: 'Em ou antes de',
  filterOperatorIsEmpty: 'Está vazio',
  filterOperatorIsNotEmpty: 'Não está vazio',
  filterOperatorIsAnyOf: 'É qualquer um dos',
  filterValueAny: 'Qualquer',
  filterValueTrue: 'Verdadeiro',
  filterValueFalse: 'Falso',
  columnMenuLabel: 'Menu',
  columnMenuShowColumns: 'Exibir colunas',
  columnMenuManageColumns: 'Gerenciar colunas',
  columnMenuFilter: 'Filtrar',
  columnMenuHideColumn: 'Ocultar',
  columnMenuUnsort: 'Remover ordenação',
  columnMenuSortAsc: 'Ordenar ASC',
  columnMenuSortDesc: 'Ordenar DESC',
  columnHeaderFiltersTooltipActive: (count) =>
    count !== 1 ? `${count} filtros ativos` : `${count} filtro ativo`,
  columnHeaderFiltersLabel: 'Mostrar filtros',
  columnHeaderSortIconLabel: 'Ordenar',
  footerRowSelected: (count) =>
    count !== 1 ? `${count} linhas selecionadas` : `${count} linha selecionada`,
  footerTotalRows: 'Total de linhas:',
  footerTotalVisibleRows: (visibleCount, totalCount) =>
    `${visibleCount} de ${totalCount}`,
  checkboxSelectionHeaderName: 'Selecionar tudo',
  checkboxSelectionSelectAllRows: 'Selecionar todas as linhas',
  checkboxSelectionUnselectAllRows: 'Desmarcar todas as linhas',
  checkboxSelectionSelectRow: 'Selecionar linha',
  checkboxSelectionUnselectRow: 'Desmarcar linha',
  booleanCellTrueLabel: 'Sim',
  booleanCellFalseLabel: 'Não',
  actionsCellMore: 'Mais',
  pinToLeft: 'Fixar à esquerda',
  pinToRight: 'Fixar à direita',
  unpin: 'Desafixar',
  treeDataGroupingHeaderName: 'Agrupamento',
  treeDataExpand: 'Expandir',
  treeDataCollapse: 'Recolher',
  groupingColumnHeaderName: 'Agrupamento',
  groupColumn: (name) => `Agrupar por ${name}`,
  unGroupColumn: (name) => `Desagrupar ${name}`,
  detailPanelToggle: 'Alternar painel de detalhes',
  expandDetailPanel: 'Expandir',
  collapseDetailPanel: 'Recolher',
  rowReorderingHeaderName: 'Reordenar linhas',
  aggregationMenuItemHeader: 'Agregação',
  aggregationFunctionLabelSum: 'Soma',
  aggregationFunctionLabelAvg: 'Média',
  aggregationFunctionLabelMin: 'Mínimo',
  aggregationFunctionLabelMax: 'Máximo',
  aggregationFunctionLabelSize: 'Tamanho',
  MuiTablePagination: {
    labelRowsPerPage: 'Linhas por página:',
  },
};

export default localeTextPTBR;
